module.exports = __webpack_public_path__ + "09b0415c401d21c853d97bb33c39a40b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2640
// module chunks = 0